import React, { useEffect } from 'react';
import { Title } from '../../components/developers/page-components/Title';
import { useTranslation } from 'react-i18next';
import { LinkComponent } from '../../components/LinkComponent';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { fetchSftpConfig } from '../../store/merchnts/actions/sftp';
import { BASE_URL } from '../../../config/environmentConfig';
import { KeyContainer } from '../../components/developers/KeyContainer';
import { Spinner } from '../../components/Spinner';
import { SFTPPublicKey } from '../../components/developers/sftp/SFTPPublicKey';
import { RightSideContainer } from '../../components/developers/RightSideContainer';
import { SFTPPrivateKey } from '../../components/developers/sftp/SFTPPrivateKey';

export const Sftp = (): JSX.Element => {
	const { t } = useTranslation();
	const { merchantState: { sftpConfig, isSftpLoading }, dispatch } = useMerchants();

	const credentials = [
		{
			key: 'url',
			name: 'SFTP.URL',
			value: sftpConfig?.url
		},
		{
			key: 'port',
			name: 'SFTP.PORT',
			value: sftpConfig?.port
		},
		{
			key: 'username',
			name: 'SFTP.USERNAME',
			value: sftpConfig?.username
		},
		// {
		// 	key: 'password',
		// 	name: 'SFTP.PASSWORD',
		// 	value: sftpConfig?.password
		// },

	];

	const sftpClients = [
		{
			key: 'fileZilla',
			name: 'SFTP.FILE_ZILLA',
			link: BASE_URL.FILE_ZILLA_URL,
			linkText: `download ${t('SFTP.FILE_ZILLA')}`
		},
		{
			key: 'winSCP',
			name: 'SFTP.WIN_SCP',
			link: BASE_URL.WIN_SCP_URL,
			linkText: `download ${t('SFTP.WIN_SCP')}`
		}
	];

	useEffect(() => {
		void fetchSftpConfig(dispatch);
	}, []);

	const getCredentialsBody = (): JSX.Element => {
		if (sftpConfig?.url
			&& sftpConfig?.port
			&& sftpConfig?.username
			&& sftpConfig?.password
		) {
			return (
				<>
					{
						credentials.map(({ key, name, value }): JSX.Element => (
							<KeyContainer
								key={key}
								value={String(value)}
								title={t(name)}
								loading={isSftpLoading}
								canCopy
								copyWithText
								additionalCopyClass="ms-3"
							/>
						))
					}
					<SFTPPublicKey/>
					<SFTPPrivateKey/>
				</>
			);
		} else {
			return (
				<div className="h-md-200px d-md-flex flex-column align-items-center justify-content-center">
					<div className="text-center fw-bolder fs-5 mb-3">{t('SFTP.NO_SFTP_TITLE')}</div>
					<div className="text-center">
						{t('SFTP.NO_SFTP_TEXT_1')} {' '}
						<LinkComponent text={t('SFTP.NO_SFTP_TEXT_2')} link='mailto:support@flex-charge.com' isUnderLine/> {' '}
						{t('SFTP.NO_SFTP_TEXT_3')}
					</div>
				</div>
			);
		}
	};

	return (
		<div className="card">
			<div className="d-md-flex">
				<div className="card-body col-md-6">
					<Title title={t('SFTP.CREDENTIALS')} additionalClass="fs-4 fw-bolder mb-5"/>

					{
						isSftpLoading
						? (
							<div className="h-md-200px pt-md-20">
								<Spinner/>
							</div>
							)
						: getCredentialsBody()
					}

				</div>
				<div className="card-body  col-md-6">
					<RightSideContainer
						title={t('SFTP.INFORMATION')}
						text={t('SFTP.INFORMATION_TEXT')}
						linkText={t('TOKENIZATION.LEARN_MORE')}
						link={BASE_URL.SFTP_URL}
						isUnderLine
					/>
					<Title title="Popular SFTP clients:" additionalClass="fs-4 mt-5"/>
					{
						sftpClients.map(el => (
							<div className="d-flex mt-5 fs-6" key={el.key}>
								<div className="col-3 col-sm-3 col-md-3 col-xl-2">{t(el.name)}:</div>
								<LinkComponent
									text={el.linkText}
									link={el.link}
									additionalClass="fs-6 d-block text-truncate"
								/>
							</div>
						))
					}
				</div>
			</div>
		</div>
	);
};
